import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Typography, Box, Button, CircularProgress } from "@mui/material";
import { savePaymentDetails } from "../services/billing.service";

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Use location hook to get query parameters
  const [loading, setLoading] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState<any>(null);

  // Get sessionId from the URL query parameters
  const sessionId = new URLSearchParams(location.search).get("session_id");

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        if (!sessionId) {
          console.error("Session ID is missing.");
          navigate("/error"); // Redirect to an error page if sessionId is missing
          return;
        }

        // // Retrieve session details from your backend using sessionId
        // const response:any = await httpClient(`/api/retrieve-session?session_id=${sessionId}`);
        // const data = await response.json();

        // Save payment details to your backend
        const saveResponse = await savePaymentDetails({
          userEmail: data.customer_email,        // Save the email of the user who made the payment
          paymentStatus: "success",             // Mark the payment status as success
          amount: data.amount_total / 100,      // Save the payment amount
          timestamp: new Date(),                // Record the payment timestamp
        });
console.log(saveResponse)
        // if (saveResponse.hasError) {
        //   console.error("Failed to save payment details:", saveResponse.message);
        //   setAlert({ message: "Failed to save payment details", severity: "error" });
        // } else {
        //   console.log("Payment details saved successfully.");
        //   setAlert({ message: "Payment successful", severity: "success" });
        // }

        setPaymentDetails(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching or saving payment details:", error);
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, [sessionId, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
      bgcolor="#f5f5f5"
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <Typography variant="h4" fontWeight="bold" mb={2}>
            Payment Successful!
          </Typography>
          <Typography variant="body1" mb={4}>
            Thank you for your payment. Your transaction details have been saved successfully.
          </Typography>
          <Typography variant="body1" mb={4}>
            Amount: ₹{paymentDetails?.amount_total / 100} {/* Show the total amount */}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/dashboard")} // Update this route as needed
          >
            Go to Dashboard
          </Button>
        </>
      )}
    </Box>
  );
};

export default Success;
